import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id D6B79C3B-22FB-4B52-90B8-6979AB48C3E8
 * name format-pilcrow-arrow-right
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-pilcrow-arrow-right.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatPilcrowArrowRightIcon = createSvgIcon(<><path d="M21,18L17,14V17H5V19H17V22M9,10V15H11V4H13V15H15V4H17V2H9A4,4 0 0,0 5,6A4,4 0 0,0 9,10Z" /></>, 'FormatPilcrowArrowRightIcon');
export default FormatPilcrowArrowRightIcon